/**
 * Company Controls Service
 * HTTP operations for company controls catalog
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetCompanyControlsOut, CompanyControl } from './companyControls.types';
import { mapCompanyControls } from './companyControls.mapper';


export class CompanyControlsService {
  /**
   * Get company controls catalog
   * GET /v{version}/catalog/company-controls
   */
  async getCompanyControls(signal?: AbortSignal): Promise<ApiResponse<CompanyControl[]>> {
    const endpoint = API_CONFIG.ENDPOINTS.CATALOG.COMPANY_CONTROLS;
    const response = await apiClient.get<LC_GetCompanyControlsOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapCompanyControls(response.data) };
  }
}

export const companyControlsService = new CompanyControlsService();
